import type { NormalizedStatisticsApiRow } from './filterableRecord'

/** Stable key matches DB unique (vendor_origin_record_type, event_id). */
export function dedupeNormalizedApiRows(rows: NormalizedStatisticsApiRow[]): NormalizedStatisticsApiRow[] {
  const m = new Map<string, NormalizedStatisticsApiRow>()
  for (const r of rows) {
    const k = `${r.vendor_origin_record_type ?? ''}:${String(r.event_id)}`
    m.set(k, r)
  }
  return Array.from(m.values())
}
